export default __webpack_public_path__ + "static/media/element_spec_17.107ebd66.webp";